export enum RequestStatusEnum {
  ALL = 'all',
  OPENED = 'opened',
  /* ACCEPTED = 'accepted', */
  /* REFUSED = 'refused', */
  IN_PROGRESS = 'inProgress',
  ARCHIVED = 'archived',
  /* PAUSED = 'paused', */
  /* ANALYSIS_COMPLETED = 'analysisCompleted', */
  AWAITING_VALIDATION = 'awaitingValidation',
  FINISHED = 'finished'
}
